import React, { useState } from 'react';
import './common.css';
import './Login.css';
import { FaUser, FaLock } from 'react-icons/fa';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
  if (!username || !password) {
    alert("Please enter both fields");
    return;
  }

  setLoading(true);

  try {
    const response = await fetch('https://promo.myservicecircle.app/webservice/loginCheck.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password })
    });

    const result = await response.json();

    if (result.success === 1) {
      localStorage.setItem('user', username);
      localStorage.setItem('pass', password);
      window.location.href = '/Dashboard'; // or use useNavigate() if you want
    } else if (result.success === 2) {
      alert("Incorrect password");
    } else {
      alert("User not found or server error");
    }

  } catch (err) {
    console.error(err);
    alert("Network/server error");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="login-container" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: 'linear-gradient(to right, #dfe9f3, #ffffff)'
    }}>
      <img
        src={require('../assets/media/images/logo.png')}
        alt="Logo"
        style={{ width: '25%', marginBottom: 30 }}
      />

      <div style={{
        width: 350,
        backgroundColor: '#fff',
        padding: 30,
        borderRadius: 16,
        boxShadow: '0 8px 30px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ marginBottom: 20, fontWeight: '600', textAlign: 'center' }}>Welcome back to the promos module</h3>

        <div className="input-group" style={{ marginBottom: 15,flexDirection:'row',justifyContent:'center',alignItems:'center',display:'flex' }}>
          <FaUser style={{ marginRight: 10, color: '#888' }} />
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '1px solid #ccc',
              borderRadius: 8
            }}
          />
        </div>

        <div className="input-group" style={{ marginBottom: 15,flexDirection:'row',justifyContent:'center',alignItems:'center',display:'flex' }}>
          <FaLock style={{ marginRight: 10, color: '#888' }} />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '1px solid #ccc',
              borderRadius: 8
            }}
          />
        </div>

        <button
          onClick={handleLogin}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: '#2f80ed',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontWeight: 'bold',
            cursor: 'pointer'
          }}

          disabled={loading}
        >
          Sign In
        </button>
      </div>
    </div>
  );
};

export default Login;
